module.exports = __webpack_public_path__ + "img/fecha.60b8c37e.png";